import type { VideoApprovalStatus, VideoAssetStatus, VideoFailureReason, VideoUpdate } from '../types';

const FAILURE_REASONS: string[] = ['too_long', 'resolution_too_high', 'unreadable'] satisfies VideoFailureReason[];
const APPROVAL_STATUSES: string[] = ['scanning', 'in_review', 'approved'] satisfies VideoApprovalStatus[];

// Reads one message from a video's cable stream. Returns null for anything that is
// not a known update, so hosts can forward messages without trusting their shape.
export const parseVideoUpdate = (data: unknown): VideoUpdate | null => {
  if (!data || typeof data !== 'object') return null;

  const message = data as Record<string, unknown>;
  if (message.type === 'status' && typeof message.status === 'string' && typeof message.revision === 'number') {
    return {
      type: 'status',
      status: message.status as VideoAssetStatus,
      revision: message.revision,
      ...(typeof message.retryable === 'boolean' && { retryable: message.retryable }),
      ...(FAILURE_REASONS.includes(message.reason as string) && { reason: message.reason as VideoFailureReason }),
      ...(APPROVAL_STATUSES.includes(message.approval_status as string) && {
        approvalStatus: message.approval_status as VideoApprovalStatus,
      }),
    };
  }
  if (message.type === 'thumbnails') return { type: 'thumbnails' };

  return null;
};
